import { render, staticRenderFns } from "./three-column.vue?vue&type=template&id=47289f5a&scoped=true&"
import script from "./three-column.vue?vue&type=script&lang=js&"
export * from "./three-column.vue?vue&type=script&lang=js&"
import style0 from "./three-column.vue?vue&type=style&index=0&id=47289f5a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47289f5a",
  null
  
)

export default component.exports